var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
export var usePublisherFilters = function () {
    var history = useHistory();
    var location = useLocation();
    var initialFilters = {
        name: "",
        owner: "",
        regionId: "",
        publisherPrefix: "",
    };
    var _a = useState(initialFilters), filters = _a[0], setFilters = _a[1];
    var _b = useState(initialFilters), appliedFilters = _b[0], setAppliedFilters = _b[1];
    var updateUrlWithFilters = function (newFilters) {
        var params = new URLSearchParams();
        if (newFilters.name)
            params.set("name", newFilters.name);
        if (newFilters.owner)
            params.set("owner", newFilters.owner);
        if (newFilters.regionId)
            params.set("regionId", newFilters.regionId);
        if (newFilters.publisherPrefix)
            params.set("publisherPrefix", newFilters.publisherPrefix);
        history.push({ search: params.toString() });
    };
    var handleFilterChange = function (field, value) {
        var _a;
        var newFilters = __assign(__assign({}, filters), (_a = {}, _a[field] = value, _a));
        setFilters(newFilters);
    };
    var handleApplyFilters = function () {
        setAppliedFilters(filters);
        updateUrlWithFilters(filters);
    };
    var handleClearFilters = function () {
        var clearedFilters = initialFilters;
        setFilters(clearedFilters);
        setAppliedFilters(clearedFilters);
        history.push({ search: "" });
    };
    var isAnyFilterActive = function () {
        return (appliedFilters.name.length > 0 ||
            appliedFilters.owner.length > 0 ||
            appliedFilters.regionId.length > 0 ||
            appliedFilters.publisherPrefix.length > 0);
    };
    var hasUnappliedChanges = function () {
        return JSON.stringify(filters) !== JSON.stringify(appliedFilters);
    };
    useEffect(function () {
        var queryParams = new URLSearchParams(location.search);
        var newFilters = {
            name: queryParams.get("name") || "",
            owner: queryParams.get("owner") || "",
            regionId: queryParams.get("regionId") || "",
            publisherPrefix: queryParams.get("publisherPrefix") || "",
        };
        if (JSON.stringify(newFilters) !== JSON.stringify(appliedFilters)) {
            setFilters(newFilters);
            setAppliedFilters(newFilters);
        }
    }, [location.search, appliedFilters]);
    return {
        filters: filters,
        appliedFilters: appliedFilters,
        handleFilterChange: handleFilterChange,
        handleApplyFilters: handleApplyFilters,
        handleClearFilters: handleClearFilters,
        isAnyFilterActive: isAnyFilterActive,
        hasUnappliedChanges: hasUnappliedChanges,
    };
};
